import styled from "styled-components";

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  width: 400px;
`;

export const ModalTitle = styled.h3`
  margin-bottom: 16px;
`;

export const Text = styled.p`
  font-size: 14px;
  margin-bottom: 20px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button`
  background-color: ${(props) =>
    props.color === "secondary" ? "#dc3545" : "#16b875"};
  color: white;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) =>
      props.color === "secondary" ? "#c82333" : "#45c18d"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled(Button)`
  background-color: #16b875;

  &:hover {
    background-color: #45c18d;
  }
`;

export const CancelButton = styled(Button)`
  background-color: #6c757d;

  &:hover {
    background-color: #5a6268;
  }
`;
